export const MOCK_EXTERNALIZED_CONFLUENCE_PAGE: {
	data: {
		cypherQuery: {
			edges: {
				node: {
					columns: {
						key: string;
						value: {
							id: string;
							data: {
								__typename: string;
								id: string;
								pageId: string;
								title: string;
								createdAt: string;
								lastUpdatedAt: string;
								status: string;
								webUrl: string;
								editUrl: string;
								space: {
									id: string;
								};
								author: {
									__typename: string;
								};
								lastEditor: {
									__typename: string;
								};
								owner: {
									__typename: string;
								};
							};
						};
					}[];
				};
			}[];
		};
	};
	extensions: {
		request_id: string;
		trace_id: string;
	};
} = {
	data: {
		cypherQuery: {
			edges: [
				{
					node: {
						columns: [
							{
								key: 'page',
								value: {
									id: 'ari:cloud:confluence:a32e5600-cd47-41af-9fa5-ca64b7866880:page/6946904',
									data: {
										__typename: 'ConfluencePage',
										id: 'ari:cloud:confluence:a32e5600-cd47-41af-9fa5-ca64b7866880:page/6946904',
										pageId: '6946904',
										title: 'Getting started in Confluence',
										createdAt: '2026-02-06T03:37:57.748Z',
										lastUpdatedAt: '2026-02-06T03:37:57.748Z',
										status: 'CURRENT',
										webUrl:
											'https://one-atlas-qdiv.atlassian.net/wiki/spaces/~63749c1177acd224b33cd882/pages/6946904/Getting+started+in+Confluence',
										editUrl:
											'https://one-atlas-qdiv.atlassian.net/wiki/pages/resumedraft.action?draftId=6946904',
										space: {
											id: 'ari:cloud:confluence:a32e5600-cd47-41af-9fa5-ca64b7866880:space/6946818',
										},
										author: {
											__typename: 'AtlassianUser',
										},
										lastEditor: {
											__typename: 'AtlassianUser',
										},
										owner: {
											__typename: 'AtlassianUser',
										},
									},
								},
							},
						],
					},
				},
			],
		},
	},
	extensions: {
		request_id: '6c67d252-8e0f-413d-9cb1-8c2fa71e765f',
		trace_id: '6c67d2528e0f413d9cb18c2fa71e765f',
	},
};
